import { Controller } from "@hotwired/stimulus";
const axios = require("axios");

export default class extends Controller {
	static targets = [
		"form",
		"channelLabelsContainer",
		"channelLabels",
		"labelTemplate",
		"currentQueryJson",
		"resultsContainer",
		"paginationContainer",
		"paginationProgressCount",
		"paginationProgressPercentage",
		"placeholder",
	];

	connect() {
		this.formTarget.querySelectorAll("input, select").forEach((elem) => {
			elem.addEventListener("change", (e) => {
				this.displaySelectedOptions();

				// const formData = new FormData(this.formTarget);

				// for (var pair of formData.entries()) {
				// 	console.log(pair[0] + ", " + pair[1]);
				// }
			});
		});
	}

	search(e) {
		e.preventDefault();

		const formData = new FormData(this.formTarget);
		const formParams = new URLSearchParams(formData);
		const zoeken = formParams.get("zoeken").trim();
		const type = formParams.get("type");
		const channels = [];

		// for (var pair of formData.entries()) {
		// 	console.log(pair[0] + ", " + pair[1]);
		// }

		// Group filters into array
		for (const [key, value] of formParams.entries()) {
			if (key == "channels") {
				channels.push(value);
			}
		}

		// Set path
		let pathname = "/tv/zoeken/";

		if (type == "videos") {
			pathname = "/tv/videos/";
		}

		if (type == "collections") {
			pathname = "/tv/collections/";
		}

		// Add filter params if not empty
		const searchParams = {};

		if (zoeken.length > 0) {
			searchParams.zoeken = zoeken;
		}

		if (channels.length > 0) {
			searchParams.channels = channels;
		}

		// Construct search URL
		const searchUrl =
			location.protocol +
			"//" +
			location.host +
			pathname +
			"?" +
			new URLSearchParams(searchParams).toString();

		// console.log(searchUrl);

		// Browse to URL
		window.location.href = searchUrl;
	}

	displaySelectedOptions() {
		const formData = new FormData(this.formTarget);
		const channelOptions = formData.getAll("channels");

		channelOptions.forEach((optionValue) => {
			const currentOptions =
				this.channelLabelsTarget.querySelectorAll("button");

			if (!this.containsOptionLabel(currentOptions, optionValue)) {
				const optionName = document.querySelector(
					'option[value="' + optionValue + '"]'
				).innerHTML;

				this.addOption(
					this.channelLabelsTarget,
					"channels",
					optionValue,
					optionName
				);

				this.channelLabelsContainerTarget.setAttribute("data-toggle", true);
			}
		});
	}

	addOption(target, field, value, name) {
		const createdLabel = this.labelTemplateTarget.cloneNode(true);

		createdLabel.querySelector("span").innerHTML = name;
		createdLabel.setAttribute("data-value", value);
		createdLabel.setAttribute("data-field", field);
		createdLabel.classList.remove("hidden");

		target.appendChild(createdLabel);
	}

	containsOptionLabel(currentOptions, value) {
		var containsOptionLabel = false;

		currentOptions.forEach((optionLabel) => {
			if (optionLabel.getAttribute("data-value") == value) {
				containsOptionLabel = true;
			}
		});

		return containsOptionLabel;
	}

	deleteOption(e) {
		const value = e.currentTarget.getAttribute("data-value");
		const field = e.currentTarget.getAttribute("data-field");

		const option = this.formTarget.querySelector(
			'select[name="' + field + '"] option[value="' + value + '"]'
		);

		const button = option.parentNode.parentNode.querySelector(
			'button.group-toggleable-secondary[data-value="' + value + '"]'
		);

		option.selected = false;

		button.removeAttribute("data-group-toggle-secondary");
		button.disabled = false;

		e.currentTarget.remove();

		if (this.channelLabelsTarget.innerHTML.trim() == "") {
			this.channelLabelsContainerTarget.removeAttribute("data-toggle");
		}

		this.setPlaceholder();
	}

	setPlaceholder() {
		const buttons = document.querySelectorAll(
			'button.group-toggleable-secondary[data-group-toggle-secondary]'
		);

		const parentContainer = this.placeholderTarget.parentNode.parentNode;
		if(buttons.length == 0) {
			this.placeholderTarget.innerHTML = 'Channel';
			if(parentContainer.classList.contains('filter-active')) {
				parentContainer.classList.remove('filter-active')
			}
		} else {
			this.placeholderTarget.innerHTML = 'Channel (' + buttons.length + ')';
			if(!parentContainer.classList.contains('filter-active')) {
				parentContainer.classList.add('filter-active')
			}
		}
	}

	showMore(e) {
		e.preventDefault();

		const button = e.currentTarget;
		const buttonLoadingContainer = button.parentNode;

		// Set button to loading
		buttonLoadingContainer.setAttribute("data-group-loading", true);
		e.currentTarget.disabled = true;

		const formData = new FormData();
		formData.append("action", "emerce_tv_search");

		const currentQuery = JSON.parse(this.currentQueryJsonTarget.innerHTML);

		// Fill formData with currentQuery
		Object.keys(currentQuery).forEach((key) =>
			formData.append(key, currentQuery[key])
		);

		// Add current page to formData
		formData.append(
			"page",
			parseInt(this.formTarget.getAttribute("data-page"))
		);

		// for (var pair of formData.entries()) {
		// 	console.log(pair[0] + ", " + pair[1]);
		// }

		axios
			.post(mainScriptData.ajaxUrl, formData)
			.then((response) => {
				if (response.data.status == "success") {
					this.formTarget.setAttribute(
						"data-page",
						parseInt(formData.get("page")) + 1
					);

					// Insert new items in page
					this.resultsContainerTarget.innerHTML += response.data.html;

					// Update progress bar
					if (response.data.currentResultsProgressPercentage <= 100) {
						this.paginationProgressCountTarget.innerHTML =
							response.data.currentResultsCount;
						this.paginationProgressPercentageTarget.style.width =
							response.data.currentResultsProgressPercentage + "%";
					} else {
						this.paginationContainerTarget.classList.add("hidden");
					}
				}

				// Disable loader
				buttonLoadingContainer.removeAttribute("data-group-loading");
				button.disabled = false;
			})
			.catch((error) => {
				console.log(error);

				// Disable loader on error
				buttonLoadingContainer.removeAttribute("data-group-loading");
				button.disabled = false;
			});
	}
}
